var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElement87(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 416 241",
    style: {
      enableBackground: "new 0 0 416 241"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "149.6,240.5 75.1,240.5 0.6,120.5 75.1,0.5 149.6,0.5  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.8,73.2h3.7l6.4,17.9l6.4-17.9H96l-8.4,22.2h-3.5L75.8,73.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.2,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H97.2z M108.1,85.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H108.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.3,79.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140,95.4h-3.1v-2.8c-1.1,2.2-3.5,3.3-6.1,3.3c-5.2,0-8.4-4.1-8.4-8.6c0-5,3.6-8.6,8.4-8.6 c3.2,0,5.3,1.8,6.1,3.4v-2.9h3.1V95.4z M125.5,87.3c0,2.4,1.7,5.7,5.7,5.7c2.5,0,4.3-1.4,5.1-3.2c0.4-0.8,0.5-1.6,0.6-2.4 c0-0.8-0.1-1.7-0.5-2.4c-0.8-1.9-2.6-3.4-5.2-3.4C127.8,81.5,125.5,84.2,125.5,87.3L125.5,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.1,79.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6H156v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.3,81.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4h-3.1v13.9h-3.1V81.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.1,79.1h3.3l3.8,12.3l3.5-11.4h2.6l3.5,11.4l3.8-12.3h3.2l-5.4,16.3h-3L183,84l-3.4,11.4h-3 L171.1,79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M195.6,87.2c0-4.3,3.2-8.6,8.7-8.6s8.7,4.3,8.7,8.6c0,4.4-3.2,8.6-8.7,8.6S195.6,91.6,195.6,87.2 L195.6,87.2z M198.7,87.3c0,3.2,2.5,5.7,5.6,5.7c3.1,0,5.6-2.4,5.6-5.7c0-3.3-2.5-5.7-5.6-5.7C201.2,81.5,198.7,84,198.7,87.3 L198.7,87.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216.2,79.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M228.1,81.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4h-3.1v13.9h-3.1V81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251.8,95.4h-2.9v-2.5c-0.8,1.7-2.6,3-5.5,3c-5.2,0-6.6-3.8-6.6-7.2v-9.6h3.1v8.8c0,2.9,1.1,5,4.3,5 c3.1,0,4.5-2,4.5-4.8v-9.1h3.1V95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.9,79.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.2v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.4,93.5c0,2.8-0.7,4.7-1.9,6.1c-1.5,1.7-4,3-6.9,3c-4.6,0-7.3-2.7-8.1-5.4h3.6c0.4,0.7,1,1.4,1.8,1.9 c1,0.7,2.1,0.9,2.8,0.9c2.7,0,5.5-2,5.5-5.7v-1.7c-1,1.8-2.9,3.4-5.9,3.4c-4.9,0-8.4-3.7-8.4-8.6c0-5.1,3.7-8.7,8.4-8.7 c2.7,0,5,1.4,5.9,3.2v-2.8h3.1V93.5z M277.1,87.2c0,3.1,2.2,5.7,5.6,5.7c1.7,0,3-0.6,4-1.7c1-1,1.6-2.4,1.6-4 c0-1.3-0.4-2.8-1.3-3.9c-0.9-1.1-2.3-1.9-4.3-1.9C279.7,81.5,277.1,83.9,277.1,87.2L277.1,87.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302.7,83.3c0-1.3-0.8-2.2-2.4-2.2c-1.5,0-2.4,1-2.3,2.1c0.1,1.3,1.2,1.9,3,2.4c2.5,0.7,5.2,1.4,5.3,4.9 c0.1,3.2-2.6,5.3-5.8,5.3c-2.6,0-5.8-1.5-5.9-5.2h3.1c0.1,2,1.7,2.6,2.9,2.6c1.5,0,2.7-1,2.7-2.4c0-1.6-1.3-2.2-4.2-3.1 c-2.3-0.7-4.1-1.8-4.1-4.2c0-3.1,2.5-4.9,5.5-4.9c2.2,0,5.2,1.1,5.4,4.7H302.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M317.1,95.4H314l-6.2-16.3h3.3l4.5,12.4l4.5-12.4h3.3L317.1,95.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M324,87.2c0-4.3,3.2-8.6,8.7-8.6c5.5,0,8.7,4.3,8.7,8.6c0,4.4-3.2,8.6-8.7,8.6 C327.2,95.9,324,91.6,324,87.2L324,87.2z M327.1,87.3c0,3.2,2.5,5.7,5.6,5.7c3.1,0,5.6-2.4,5.6-5.7c0-3.3-2.5-5.7-5.6-5.7 C329.5,81.5,327.1,84,327.1,87.3L327.1,87.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M344.5,73.2h3.1v22.2h-3.1V73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M351.7,73.2h3.1v22.2h-3.1V73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M360.9,88.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.7,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H360.9z M371.8,85.8 c-0.2-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H371.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378,79.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8H378V79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M92.5,131.4h-2.9v-2.5c-0.8,1.7-2.6,3-5.5,3c-5.2,0-6.6-3.8-6.6-7.2v-9.6h3.1v8.9c0,2.9,1.1,5,4.3,5 c3.1,0,4.5-2,4.5-4.8v-9.1h3.1V131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.6,115.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.1v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.2,131.4h-3v-2.8c-0.9,1.7-2.7,3.3-6.1,3.3c-5.1,0-8.4-4-8.4-8.7c0-5.1,3.7-8.6,8.3-8.6 c3.3,0,5.4,1.9,6,3.1v-2.9v-5.7h3.1V131.4z M117.9,123.2c0,3,2.1,5.7,5.7,5.7c1.6,0,3.1-0.7,4.1-1.7c1-1,1.6-2.5,1.6-4.1 c0-1.6-0.6-3-1.6-4c-1-1-2.4-1.6-4-1.6C120.1,117.5,117.9,120.1,117.9,123.2L117.9,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.7,129.5c0,2.8-0.7,4.7-1.9,6.1c-1.5,1.7-4,3-6.9,3c-4.6,0-7.3-2.7-8.1-5.4h3.6c0.4,0.7,1,1.4,1.8,1.9 c1,0.7,2.1,0.9,2.8,0.9c2.7,0,5.5-2,5.5-5.7v-1.7c-1,1.8-2.9,3.4-5.9,3.4c-4.9,0-8.4-3.7-8.4-8.6c0-5.1,3.7-8.7,8.4-8.7 c2.7,0,5,1.4,5.9,3.2v-2.8h3.1V129.5z M147.4,123.2c0,3.1,2.2,5.7,5.6,5.7c1.6,0,3-0.6,4-1.7c1-1,1.6-2.4,1.6-4 c0-1.3-0.4-2.8-1.3-3.9c-0.9-1.1-2.3-1.9-4.3-1.9C149.9,117.5,147.4,119.9,147.4,123.2L147.4,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M167.7,124.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H167.7z M178.6,121.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H178.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.9,117.5H183v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4H189v13.9h-3.1V117.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194.5,115.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V115.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.7,124.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.7,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H205.7z M216.6,121.8 c-0.2-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.3,2.3-5.4,4.5H216.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.7,131.4h-2.9v-2.5c-0.8,1.7-2.6,3-5.5,3c-5.2,0-6.6-3.8-6.6-7.2v-9.6h3.1v8.9c0,2.9,1.1,5,4.3,5 c3.1,0,4.5-2,4.5-4.8v-9.1h3.1V131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M243.8,124.2c0.2,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.6,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H243.8z M254.7,121.8 c-0.1-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H254.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.8,115.1h2.9v2.4c0.9-1.9,2.6-2.8,4.9-2.9v3.1h-0.2c-2.9,0-4.5,1.6-4.5,4.9v8.8h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.4,109.2v13.9c0,1.4,0,2.6,0.8,3.9c0.7,1,1.9,1.8,3.4,1.8c1.5,0,2.8-0.7,3.4-1.7 c0.8-1.3,0.8-2.5,0.8-3.9v-13.9h3.5v13.9c0,2.9-0.5,5.2-2.4,6.8c-1.3,1.2-3.1,2-5.3,2c-1.6,0-3.9-0.5-5.4-1.9 c-2.2-2-2.5-4.1-2.4-6.8v-13.9H283.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.4,115.1h2.9v2.3c0.7-1.4,2.6-2.8,5-2.8c1.5,0,3.1,0.4,4.2,1.7c0.4,0.4,0.9,1.3,1,1.6 c0.3-0.5,0.6-1,1.2-1.6c1.1-1,2.6-1.7,4.3-1.7c1.5,0,3.2,0.4,4.4,1.6c1.4,1.5,1.8,3,1.8,6.1v9h-3.1v-8.9c0-1.4-0.2-2.7-0.9-3.6 c-0.6-0.8-1.4-1.3-2.9-1.3c-1.4,0-2.5,0.6-3.1,1.6c-0.7,1-0.8,1.9-0.8,3.3v9h-3.2v-9c0-1.4-0.1-2.3-0.7-3.2 c-0.6-1-1.6-1.6-3.1-1.6c-1.5,0-2.5,0.7-3.1,1.6c-0.6,0.9-0.9,2-0.9,3.3v8.9h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M344.7,129.5c0,2.8-0.7,4.7-1.9,6.1c-1.5,1.7-4,3-6.9,3c-4.6,0-7.3-2.7-8.1-5.4h3.6c0.4,0.7,1,1.4,1.8,1.9 c1,0.7,2.1,0.9,2.8,0.9c2.7,0,5.5-2,5.5-5.7v-1.7c-1,1.8-2.9,3.4-5.9,3.4c-4.9,0-8.4-3.7-8.4-8.6c0-5.1,3.7-8.7,8.4-8.7 c2.7,0,5,1.4,5.9,3.2v-2.8h3.1V129.5z M330.4,123.2c0,3.1,2.2,5.7,5.6,5.7c1.7,0,3-0.6,4-1.7c1-1,1.6-2.4,1.6-4 c0-1.3-0.4-2.8-1.3-3.9c-0.9-1.1-2.3-1.9-4.3-1.9C333,117.5,330.4,119.9,330.4,123.2L330.4,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M365.4,131.4h-3.1v-2.8c-1.1,2.2-3.5,3.3-6.1,3.3c-5.2,0-8.4-4.1-8.4-8.6c0-5,3.6-8.6,8.4-8.6 c3.2,0,5.3,1.8,6.1,3.4v-2.9h3.1V131.4z M351,123.3c0,2.4,1.7,5.7,5.7,5.7c2.5,0,4.3-1.4,5.1-3.2c0.4-0.8,0.5-1.6,0.6-2.4 s-0.1-1.7-0.5-2.4c-0.8-1.9-2.6-3.4-5.2-3.4C353.2,117.5,351,120.2,351,123.3L351,123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M369.5,115.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.2v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M405.1,129.5c0,2.8-0.7,4.7-1.9,6.1c-1.5,1.7-4,3-6.9,3c-4.6,0-7.3-2.7-8.1-5.4h3.6c0.4,0.7,1,1.4,1.8,1.9 c1,0.7,2.1,0.9,2.8,0.9c2.7,0,5.5-2,5.5-5.7v-1.7c-1,1.8-2.9,3.4-5.9,3.4c-4.9,0-8.4-3.7-8.4-8.6c0-5.1,3.7-8.7,8.4-8.7 c2.7,0,5,1.4,5.9,3.2v-2.8h3.1V129.5z M390.8,123.2c0,3.1,2.2,5.7,5.6,5.7c1.7,0,3-0.6,4-1.7c1-1,1.6-2.4,1.6-4 c0-1.3-0.4-2.8-1.3-3.9c-0.9-1.1-2.3-1.9-4.3-1.9C393.3,117.5,390.8,119.9,390.8,123.2L390.8,123.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.5,151.1h2.9v2.3c0.7-1.4,2.6-2.8,4.9-2.8c1.5,0,3.1,0.4,4.2,1.7c0.4,0.4,0.9,1.3,1,1.6 c0.3-0.5,0.6-1,1.2-1.6c1.1-1,2.6-1.7,4.3-1.7c1.5,0,3.2,0.4,4.4,1.6c1.4,1.5,1.8,3,1.8,6.1v9h-3.1v-8.9c0-1.3-0.2-2.7-0.9-3.6 c-0.6-0.8-1.4-1.3-2.9-1.3c-1.4,0-2.5,0.6-3.1,1.6c-0.7,1-0.8,1.9-0.8,3.3v9h-3.1v-9c0-1.3-0.1-2.3-0.7-3.2 c-0.6-1-1.6-1.6-3.1-1.6c-1.5,0-2.5,0.7-3.1,1.6c-0.6,0.9-0.9,2-0.9,3.3v8.9h-3.1V151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M106.3,145.2h3.1v3.3h-3.1V145.2z M106.3,151.1h3.1v16.3h-3.1V151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.6,153.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4h-3.1v13.9h-3.1V153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.2,145.2h6.6c2.1,0,3.6,0.4,4.7,1.2c1.6,1,2.2,2.7,2.2,4.5c0,2.3-1.2,3.8-2.8,4.6c3.8,1.2,4,4.5,4,5.5 c0,2.2-1,4-2.7,5.1c-1.6,1.1-2.9,1.3-5.6,1.3h-6.5V145.2z M135.7,154.4h2.9c0.8,0,1.6-0.1,2.2-0.4c1.1-0.6,1.5-1.6,1.5-2.7 c0-1.4-0.7-2.2-1.5-2.6c-0.5-0.3-1.2-0.4-2.3-0.4h-2.8V154.4z M135.7,164.3h3.6c0.7,0,1.6-0.1,2.4-0.4c1.1-0.5,1.9-1.4,2-3.1 c0-1.5-0.8-2.6-2-3.1c-0.9-0.4-1.6-0.4-2.7-0.4h-3.3V164.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.1,167.4h-2.9v-2.5c-0.8,1.7-2.6,3-5.5,3c-5.2,0-6.6-3.8-6.6-7.2v-9.6h3.1v8.8c0,2.9,1.1,5,4.3,5 c3.1,0,4.5-2,4.5-4.8v-9.1h3.1V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M185.7,167.4h-3v-2.8c-0.9,1.7-2.7,3.3-6.1,3.3c-5.1,0-8.4-4-8.4-8.7c0-5.1,3.7-8.6,8.3-8.6 c3.3,0,5.4,1.9,6,3.1v-2.9v-5.7h3.1V167.4z M171.4,159.2c0,3,2.1,5.7,5.7,5.7c1.6,0,3.1-0.7,4.1-1.7c1-1,1.6-2.5,1.6-4.1 c0-1.6-0.6-3-1.6-4c-1-1-2.4-1.6-4-1.6C173.7,153.5,171.4,156.2,171.4,159.2L171.4,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.4,165.5c0,2.8-0.7,4.7-1.9,6.1c-1.5,1.7-4,3-6.9,3c-4.6,0-7.3-2.7-8.1-5.4h3.6c0.4,0.7,1,1.4,1.8,1.9 c1,0.7,2.1,0.9,2.8,0.9c2.7,0,5.5-2,5.5-5.7v-1.7c-1,1.8-2.9,3.4-5.9,3.4c-4.9,0-8.4-3.7-8.4-8.6c0-5.1,3.7-8.7,8.4-8.7 c2.7,0,5,1.4,5.9,3.2v-2.8h3.1V165.5z M192,159.2c0,3.1,2.2,5.7,5.6,5.7c1.6,0,3-0.6,4-1.7c1-1,1.6-2.4,1.6-4 c0-1.3-0.4-2.8-1.3-3.9c-0.9-1.1-2.3-1.9-4.3-1.9C194.6,153.5,192,155.9,192,159.2L192,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M212.4,160.2c0.1,3.3,3,5,5.5,5c2.2,0,3.8-1.1,4.7-2.8h3.2c-0.8,1.8-1.9,3.2-3.3,4c-1.4,0.9-3,1.4-4.7,1.4 c-5.3,0-8.6-4.3-8.6-8.6c0-4.7,3.7-8.7,8.6-8.7c2.3,0,4.5,0.9,6,2.4c1.9,2,2.7,4.5,2.5,7.2H212.4z M223.3,157.8 c-0.2-2.2-2.3-4.6-5.4-4.5c-3.2,0-5.2,2.3-5.4,4.5H223.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.6,153.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.2v2.4h-3.2v13.9h-3.1V153.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M246.4,155.3c0-1.3-0.8-2.2-2.4-2.2c-1.5,0-2.4,1-2.3,2.1c0.1,1.3,1.2,1.9,3,2.4c2.5,0.7,5.2,1.4,5.3,4.9 c0.1,3.2-2.6,5.3-5.8,5.3c-2.6,0-5.8-1.5-5.9-5.2h3.1c0.1,2,1.7,2.6,2.9,2.6c1.5,0,2.7-1,2.7-2.4c0-1.6-1.3-2.2-4.2-3.1 c-2.3-0.7-4.1-1.8-4.1-4.2c0-3.1,2.5-4.9,5.5-4.9c2.2,0,5.2,1.1,5.4,4.7H246.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.1,167.4h-2.9v-2.5c-0.8,1.7-2.6,3-5.5,3c-5.2,0-6.6-3.8-6.6-7.2v-9.6h3.1v8.8c0,2.9,1.1,5,4.3,5 c3.1,0,4.5-2,4.5-4.8v-9.1h3.1V167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.1,151.1h2.9v2.5c0.8-1.7,2.6-3,5.5-3c5.2,0.1,6.6,3.8,6.6,7.2v9.6h-3.2v-8.8c0-2.9-1.1-5-4.3-5 c-3.1,0-4.5,2-4.5,4.8v9.1h-3.1V151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.8,167.4h-3v-2.8c-0.9,1.7-2.7,3.3-6.1,3.3c-5.1,0-8.4-4-8.4-8.7c0-5.1,3.7-8.6,8.3-8.6 c3.3,0,5.4,1.9,6,3.1v-2.9v-5.7h3.1V167.4z M302.4,159.2c0,3,2.1,5.7,5.7,5.7c1.6,0,3.1-0.7,4.1-1.7c1-1,1.7-2.5,1.6-4.1 c0-1.6-0.6-3-1.6-4c-1-1-2.4-1.6-4-1.6C304.7,153.5,302.4,156.2,302.4,159.2L302.4,159.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M329.8,145.2h12.4v3.1h-8.9v6.3h8.8v3.1h-8.8v6.6h8.9v3.1h-12.4V145.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M347,153.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4h-3.1v13.9H347V153.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M371.4,167.4h-3.1v-2.8c-1.1,2.2-3.5,3.3-6.1,3.3c-5.2,0-8.4-4.1-8.4-8.6c0-5,3.6-8.6,8.4-8.6 c3.2,0,5.3,1.8,6.1,3.4v-2.9h3.1V167.4z M357,159.3c0,2.4,1.7,5.7,5.7,5.7c2.5,0,4.3-1.4,5.1-3.2c0.4-0.8,0.5-1.6,0.6-2.4 s-0.1-1.7-0.5-2.4c-0.8-1.9-2.6-3.4-5.2-3.4C359.2,153.5,357,156.2,357,159.3L357,159.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M376.7,153.5h-2.9v-2.4h2.9v-5.9h3.1v5.9h3.1v2.4h-3.1v13.9h-3.1V153.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M392.5,155.3c0-1.3-0.8-2.2-2.4-2.2c-1.5,0-2.4,1-2.3,2.1c0.1,1.3,1.2,1.9,3,2.4c2.5,0.7,5.2,1.4,5.3,4.9 c0.1,3.2-2.6,5.3-5.8,5.3c-2.6,0-5.8-1.5-5.9-5.2h3.1c0.1,2,1.7,2.6,2.9,2.6c1.5,0,2.7-1,2.7-2.4c0-1.6-1.3-2.2-4.2-3.1 c-2.3-0.7-4.1-1.8-4.1-4.2c0-3.1,2.5-4.9,5.5-4.9c2.2,0,5.2,1.1,5.4,4.7H392.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403.1,167.4h-3.3v-3.9h3.3V167.4z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement87);
export default __webpack_public_path__ + "static/media/Element 87.eab406a8e30534e444259ff20026c75f.svg";
export { ForwardRef as ReactComponent };